<template>
    <modal
        name="reset-password-phone"
        @before-open="beforeOpen"
        @opened="opened"
        @before-close="beforeClose"
        :classes="['v--modal', 'reset-password-phone', 'error-modal']"
        :width="730"
        :height="'auto'"
        :adaptive="true"
    >
        <div class="modal-title">
            {{ $t("restoringAccess.restoringAccess") }}
        </div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <div class="form-group">
                <label for="register-password" class="label"
                    >{{ $t("restoringAccess.codeFromSms") }}:</label
                >
                <input
                    v-model="token"
                    v-validate.persist="{
                        required: true,
                    }"
                    name="token"
                    type="text"
                    class="input"
                    :class="{ 'field-error': errors.has('token') }"
                />

                <label class="v-error label-tip">{{
                    errors.first("token")
                }}</label>
            </div>
            <div class="form-group">
                <label for="register-password" class="label"
                    >{{ $t("register.password") }}:</label
                >
                <input
                    type="password"
                    v-model="password"
                    name="password"
                    id="register-password"
                    ref="password"
                    v-validate.persist="'required|min:6'"
                    autocomplete="new-password"
                    class="input"
                    :class="{ 'field-error': errors.has('password') }"
                />
                <label for="register-password" class="v-error label-tip">{{
                    errors.first("password")
                }}</label>
            </div>
            <div class="form-group">
                <label for="password-confirm" class="label"
                    >{{ $t("register.password") }}:</label
                >
                <input
                    v-model="passwordConfirm"
                    type="password"
                    name="password-confirm"
                    id="password-confirm"
                    v-validate.persist="'required|confirmed:password|min:6'"
                    autocomplete="new-password"
                    class="input"
                    :class="{ 'field-error': errors.has('password-confirm') }"
                />
                <label for="password-confirm" class="v-error label-tip">{{
                    errors.first("password-confirm")
                }}</label>
            </div>
            <div v-show="!errors.has('code')" class="label-tip">
                {{ $t("restoringAccess.codeValidityTime") }}
                <countdown
                    :time="timeExpire"
                    :transform="transform"
                    :emit-events="true"
                    ref="countdownExpire"
                    @end="codeExpired"
                >
                    <template v-show="codeEnabled" slot-scope="props">
                        <span v-if="codeEnabled">
                            <span v-if="props.minutes > 0">
                                {{ props.minutes }}
                                {{ $t("restoringAccess.minutes") }}
                            </span>
                            {{ props.seconds }}
                            {{ $t("restoringAccess.seconds") }}
                        </span>
                        <span v-if="!codeEnabled">{{
                            $t("restoringAccess.expired")
                        }}</span>
                    </template>
                </countdown>
            </div>
            <div class="form-bottom">
                <div @click="repeatCode" class="repeat-code link">
                    {{ $t("restoringAccess.resendCode") }}
                </div>
                <br />
                <button
                    @click="sendCode"
                    class="button"
                    :class="{ 'button-loader': loader }"
                >
                    {{ $t("restoringAccess.continue") }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { initAfterLogin } from "@/mixins/initAfterLogin";
import { checkScroll } from "@/mixins/checkScroll";

export default {
    name: "ResetPasswordPhone",
    mixins: [initAfterLogin, checkScroll],
    data() {
        return {
            token: "",
            disableCodeRepeat: true,
            codeEnabled: true,
            timeRepeat: 300000,
            timeExpire: 600000,
            loader: false,
            password: "",
            passwordConfirm: "",
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            userErrors: "user/fetchUserErrors",
            resetPhone: "user/fetchResetPhone",
        }),
    },
    methods: {
        beforeOpen() {
            this.checkScroll();
        },
        opened() {
            this.timeExpire = 600000;
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        sendCode() {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.loader = true;
                    this.$store
                        .dispatch("user/resetPasswordConfirm", {
                            phone: true,
                            data: {
                                phone_or_uid: this.resetPhone,
                                token: this.token,
                                password: this.password,
                            },
                        })
                        .then(() => {
                            this.loader = false;
                            this.initAfterLogin();
                            this.token = "";
                            this.password = "";
                            this.passwordConfirm = "";
                            this.errors.clear();
                            this.$validator.reset();
                            this.close();
                            if (
                                !this.isEmpty("user") &&
                                (!this.user.first_name ||
                                    !this.user.last_name ||
                                    (this.user.gender != 1 &&
                                        this.user.gender != 2) ||
                                    !this.user.birthday)
                            ) {
                                this.$modal.show("first-login");
                            }
                            const vm = new Vue();
                            vm.$connect();
                        })
                        .catch(() => {
                            this.loader = false;
                            for (let key in this.userErrors) {
                                this.errors.add({
                                    field: key,
                                    msg: this.userErrors[key][0],
                                });

                                if (key == "uid") {
                                    this.$modal.show("dialog", {
                                        title: this.$t(
                                            "restoringAccess.restoringAccess"
                                        ),
                                        text: this.$t(
                                            "restoringAccess.anErrorHasOccurred"
                                        ),
                                        buttons: [
                                            {
                                                title: this.$t("albumEdit.ok"),
                                            },
                                        ],
                                    });
                                }
                            }
                        });
                }
            });
        },
        repeatCode() {
            if (this.disableCodeRepeat) {
                return;
            }
            this.disableCodeRepeat = true;
        },
        transform(props) {
            Object.entries(props).forEach(([key, value]) => {
                props[key] = value < 10 ? `0${value}` : value;
            });
            return props;
        },
        codeExpired() {
            this.codeEnabled = false;
        },
        close() {
            this.$modal.hide("reset-password-phone");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/layout/_reset-password";
</style>
